module.exports = __webpack_public_path__ + "static/media/honeywell-logo.03ca8609.png";